import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {ReactComponent as ChevronLeft} from '../../assets/icons/chevron-left.svg'
import {ReactComponent as ChevronRight} from '../../assets/icons/chevron-right.svg'
import {ReactComponent as IconSearch} from '../../assets/icons/search.svg'
import {getAccessToken} from '../../services/AuthServices'
import {getCurrentStore} from '../../services/CurrentStoreServices'

const NavBar1 = (props) => {
    const {selectedProduct, onHandleSearch, txtSearch} = props
    const navigate = useNavigate()
    const _handleChangeInput = (e) => {
        e.preventDefault()
        const {value} = e.target
        onHandleSearch(value ? value.trim() : '')
    }

    const _navigateDesign = (selectedProduct) => {
        const accessToken = getAccessToken()
        const currentStore = getCurrentStore()
        // return window.open(
        //     `${
        //         process.env.REACT_APP_MOCKUP_DESIGN_URL || 'https://design-staging.merchize.com'
        //     }?storeId=${currentStore}&path=backoffice&productId=${selectedProduct}&accessToken=${accessToken}`,
        //     '_self'
        // )
        if (!accessToken || !currentStore) {
            return navigate(`/${selectedProduct}`)
        }
        navigate(`/${selectedProduct}?storeId=${currentStore}&path=backoffice&accessToken=${accessToken}`)
    }

    return (
        <div className="HeaderListProduct Nav1 NavCatalog">
            <div className="row RowHeaderListProduct align-items-center">
                <div className="col-10 d-flex align-items-center justify-content-end flex-wrap">
                    {/* <Link to="/a/products" className="BackButton">
                        <ChevronLeft width={11} height={18} />
                        <span className="Text">Products</span>
                    </Link> */}

                    <div className="SearchProductMockup">
                        <input
                            type="text"
                            id="SearchTitleProductMockup"
                            name="title"
                            placeholder="Search..."
                            defaultValue={txtSearch}
                            onChange={_handleChangeInput}
                        />

                        <span className="SearchIcon">
                            <IconSearch width={15} height={15} />
                        </span>
                    </div>
                </div>
                <div className="col-2 d-flex justify-content-end align-items-center">
                    <button
                        type="button"
                        id="ButtonDesign"
                        className={classNames('SelectProducts', {disabled: !selectedProduct})}
                        disabled={!selectedProduct}
                        onClick={() => _navigateDesign(selectedProduct)}
                    >
                        <span className="mr-2">Design</span>
                        <ChevronRight width={7} height={10} />
                    </button>
                </div>
            </div>
        </div>
    )
}

NavBar1.propTypes = {
    onHandleSearch: PropTypes.func.isRequired,
    txtSearch: PropTypes.string.isRequired,
    showSidebar: PropTypes.bool.isRequired,
}

export default NavBar1

